import { render, staticRenderFns } from "./PgaAccessDenied.vue?vue&type=template&id=c0c4e6e8&"
import script from "./PgaAccessDenied.vue?vue&type=script&lang=ts&"
export * from "./PgaAccessDenied.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VFlex,VImg,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0c4e6e8')) {
      api.createRecord('c0c4e6e8', component.options)
    } else {
      api.reload('c0c4e6e8', component.options)
    }
    module.hot.accept("./PgaAccessDenied.vue?vue&type=template&id=c0c4e6e8&", function () {
      api.rerender('c0c4e6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Layout/PgaAccessDenied.vue"
export default component.exports